<template>
    <div class="bigBox">
        <div class="header">
            <!-- <div class="user">{{auctionAccount}}，欢迎您!</div> -->
            <el-dropdown class="cursor">
                <div class="user">{{auctionAccount}}，欢迎您!</div>
                <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="resetLogin">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <img
                src="@/image/goback.png"
                alt=""
                style="width: 23px; height: 23px;cursor: pointer;"
                @click="goBack"
            />
        </div>
        <div class="top-tip-box">
            <div class="times-box" v-if="detailsForm.progressStatus<5">
                <p v-if="detailsForm.progressStatus==3">距竞买开始时间：</p>
                <p v-if="detailsForm.progressStatus==4">距结束时间：</p>
                <div class="time-details">
                    <div class="time-kuang">
                        <p class="time-case hongColor">{{daysTime}}</p>
                        <p class="zhongwen">天</p>
                    </div>
                    <p class="time-symbol">:</p>
                    <div class="time-kuang">
                        <p class="time-case lvColor">{{hoursTime}}</p>
                        <p class="zhongwen">时</p>
                    </div>
                    <p class="time-symbol">:</p>
                    <div class="time-kuang">
                        <p class="time-case lanColor">{{minutesTime}}</p>
                        <p class="zhongwen">分</p>
                    </div>
                    <p class="time-symbol">:</p>
                    <div class="time-kuang">
                        <p class="time-case huangColor">{{secondsTime}}</p>
                        <p class="zhongwen">秒</p>
                    </div>
                    <!-- <div class="time-case greenBg">{{daysTime}}天</div>
                    <div class="time-case yellowBg">{{hoursTime}}时</div>
                    <div class="time-case blueBg">{{minutesTime}}分</div>
                    <div class="time-case blueBg2">{{secondsTime}}秒</div> -->
                </div>
            </div>
            <div class="times-box" v-else>
                <p>竞买结束时间：{{detailsForm.finallyAuctionEndTime}}</p>
            </div>
            <div class="tips mt65 blueColor2" v-if="form.auditStatus == 0">报名材料审核中，请等待！</div>
            <div v-if="detailsForm.progressStatus==3 && (form.auditStatus == 1)">
                <div class="mt50" v-if="form.marginConfirmationUserName==null && form.bondIs==1">
                    <p class="tips greenColor">恭喜您报名资料通过审核，请及时支付项目保证金！</p>
                    <p class="tips-one">温馨提示：支付项目保证金时，请备注项目名称和编号</p>
                </div>
            </div>

            <!-- 报名后未开始 无需保证金 -->
            <div v-if="detailsForm.progressStatus==3 && form.auditStatus == 1">
                <div class="tips mt65 blueColor2" v-if="form.marginConfirmationUserName==null && form.bondIs==0">
                    恭喜您报名资料通过审核，竞买即将开始，请及时关注竞买情况!
                </div>
            </div>
            <div class="" style="" v-if="form.auditStatus == 2 && detailsForm.progressStatus<4">
                <p class="tips redColor">您的报名资料被驳回</p>
                <p class="tips redColor">请点击下方“编辑”按钮，修改后重新提交！</p>
                <p class="tips-one">驳回原因：{{form.auditReason || "--"}}</p>
            </div>
            
            <!-- 资质审核通过并且已缴纳保证金 -->
            <div v-if="detailsForm.progressStatus==3">
                <div class="tips mt65 blueColor2" v-if="(form.auditStatus == 1 && form.marginConfirmationUserName && form.bondIs==1 )">
                    平台已收到您的保证金，竞买即将开始，请及时关注竞买情况！
                </div>
            </div>
            
            <div v-if="detailsForm.progressStatus==4 && form.auditStatus == 1">
                <div class="tips mt65 blueColor2" v-if="
                (form.bondIs == 1 && form.marginConfirmationUserName) || (form.bondIs == 0 && form.marginConfirmationUserName==null)">
                    竞买进行中，请及时关注竞买情况！
                </div>
            </div>
            

            <div v-if="detailsForm.progressStatus==3 && (form.auditStatus == 1 && form.bondIs==0)">
                <div class="tips mt65 blueColor2" v-if="form.marginConfirmationUserName && form.bondIs==1">
                    竞买即将开始，请及时关注竞买情况！
                </div>
            </div>
            <!-- 项目结束 且登录的账号成为胜出者 -->
            <div class="tips mt65 greenColor" v-if="(form.isWinningBuyer==1 && detailsForm.progressStatus==5) && settlementForm.settleStatus==0">
                恭喜您成为本次竞买的胜出者，项目结算确认中，请及时联系平台！
            </div>
            <!-- 项目结束 胜出者 项目已结算 待支付 settleStatus0待核算 1待收款 2 已收款 3 已过期-->
            <div class="mt50" v-if="(detailsForm.progressStatus == 5 && form.isWinningBuyer==1) && settlementForm.settleStatus==1">
                <p class="tips greenColor">项目款项已完成确认，可联系平台进行支付！</p>
                <!-- <p class="tips-one">温馨提示：付款时请备注项目编号，如有疑问请联系平台</p> -->
            </div>
            <!-- 项目结束 胜出者 项目已结算 已支付 settleStatus0待核算 1待收款 2 已收款 3 已过期-->
            <div class="tips mt65 greenColor" v-if="(detailsForm.progressStatus == 5 && form.isWinningBuyer==1) && settlementForm.settleStatus==2">
                平台已收到您的竞买款项，请及时联系平台物资对接人进行物资交付！
            </div>
            <!-- 项目结束 竞买失败-->
            <div class="tips mt65 " v-if="(detailsForm.progressStatus == 5 && form.isWinningBuyer==0)">
                <div style="margin-bottom:10px">
                    <img src="@/image/error.png">
                </div>
                <div>您参与的本次竞价竞买失败，感谢参与！请持续关注我们的其他竞买活动！</div>
            </div>
            <!-- 项目结束 流拍-->
            <div class="tips mt65 " v-if="detailsForm.progressStatus == 6">
                <div style="margin-bottom:10px">
                    <img src="@/image/error.png">
                </div>
                <div>无人出价，本场竞价失败！</div>
            </div>
            <div class="" style="" v-if="detailsForm.progressStatus == 4 && form.auditStatus==2">
                <p class="tips redColor">项目已开始竞买，资质驳回未修改！</p>
                <p class="tips redColor">感谢您的参与，请持续关注我们的其他的竞买活动！</p>
                <p class="tips-one">温馨提示：如有疑问请联系平台</p>
            </div>
            <!-- 竞买开始报名资料未审核 竞买失败-->
            <div class="" style="" v-if="detailsForm.progressStatus == 4 && form.auditStatus==3">
                <p class="tips redColor">项目已开始竞买，资质超时未审核！</p>
                <p class="tips redColor">感谢您的参与，请持续关注我们的其他的竞买活动！</p>
                <p class="tips-one">温馨提示：如有疑问请联系平台</p>
            </div>
            <!-- 竞买开始未收到保证金 竞买失败 form.auditStatus == 1-->
            <div v-if="detailsForm.progressStatus == 4 && form.auditStatus == 1">   
                <div style="" v-if="(form.bondIs==1 && form.marginConfirmationUserName ==null) ">
                    <p class="tips redColor">项目已开始竞买，平台暂未收到您的项目保证金！</p>
                    <p class="tips redColor">如您已打款，项目结束后，平台会自动将您的保证金退回！</p>
                    <p class="tips-one">温馨提示：如有疑问请联系平台</p>
                </div>
            </div>

            <!-- 项目结束 已核算 未付款过期 settleStatus0待核算 1待收款 2 已收款 3 已过期-->
            <div class="mt50" v-if="(detailsForm.progressStatus == 5 && form.isWinningBuyer==1) && settlementForm.settleStatus==3">
                <p class="tips redColor">平台超时未收到您的本次竞买胜出的项目款，项目已过期！</p>
                <p class="tips-one">温馨提示：如有疑问请联系平台</p>
            </div>
            
        </div>

        <div class="mt20">
            <titleBar title="竞买信息"></titleBar>
            <div class="flexDiv">
                <div class="flex1">
                    <span>竞买项目名称：</span>
                    <span>{{ detailsForm.auctionProjectName }}</span>
                </div>
                <div class="flex1">
                    <span>项目编号：</span>
                    <span class="boldText codes" @click="projectClick">{{ detailsForm.auctionProjectCode }}</span>
                </div>
                <div class="flex1">
                    <span>竞买起止时间：</span>
                    <span class="boldText">{{detailsForm.auctionStartTime}}--{{detailsForm.auctionEndTime}}</span>
                </div>
            </div>
            <div class="flexDiv">
                <div class="flex1">
                    <span>延时周期：</span>
                    <span>{{ detailsForm.delayPeriod }}分钟/次</span>
                </div>
                <div class="flex1">
                    <span>是否缴纳保证金：</span>
                    <span class="boldText">{{detailsForm.bondIs==1?'是':'否'}}</span>
                </div>
                <div class="flex1" v-if="detailsForm.bondIs==1">
                    <span>保证金：</span>
                    <span class="boldText">{{detailsForm.bond || 0.00}}元</span>
                </div>
                <div class="flex1" v-if="detailsForm.bondIs==0">
                    <span></span>
                    <span class="boldText" ></span>
                </div>
            </div>
            <div class="flexDiv">
                <div class="flex1">
                    <span>限价类型：</span>
                    <span>{{detailsForm.fixedPriceType==0?'最高限价':'最低限价'}}</span>
                </div>
                <div class="flex1">
                    <span>限高价：</span>
                    <span class="boldText">￥{{detailsForm.startingPrice || 0.00}}</span>
                </div>
                <div class="flex1">
                    <span>降价幅度：</span>
                    <span class="boldText">￥{{detailsForm.priceIncrease || 0.00}}元/次</span>
                </div>
            </div>

            <titleBar title="保证金收款账户信息" style="margin-top:40px"></titleBar>
            <div class="flexDiv">
                <div class="flexDiv_right">
                    <span>收款方名称：</span>
                    <span>{{ detailsForm.unitName }}</span>
                </div>
                <div class="flexDiv_right">
                    <span>开户行：</span>
                    <span class="boldText">{{ detailsForm.bankOfDeposit }}</span>
                </div>
                <div class="flexDiv_right">
                    <span>银行账号：</span>
                    <span class="boldText">{{detailsForm.account}}</span>
                </div>
            </div>
        </div>
        <div class="dividing-line"></div>
        <!-- 资质驳回或还没闹 v-if="form.auditStatus != 1 && !form.marginConfirmationUserName"-->
        <div v-if="detailsForm.progressStatus<=3">
            <div class="mess-btn"> 
                <titleBar title="报名信息"></titleBar>
                <div v-if="(form.auditStatus == 2)">
                    <el-button class="sureBtn" @click="editClick" v-if="isDisabled">编辑</el-button>
                    <el-button class="sureBtn" @click="editForm" v-else>完成</el-button>
                </div>
            </div>
            
            <div class="form">
                <el-form
                :model="formLabelAlign"
                label-width="140px"
                size="small"
                style="overflow: hidden"
                ref="formLabelAlign"
                :rules="rules"
                >
                <div class="elFormBox">
                    <el-form-item label="买家性质：" prop="type">
                    <el-select
                        :disabled="isDisabled"
                        v-model="formLabelAlign.type"
                        style="width: 300px"
                        placeholder="请选择"
                    >
                        <el-option label="自然人" :value="1"></el-option>
                        <el-option label="企业" :value="0"></el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="买家名称：" prop="userName">
                        <el-input
                            :disabled="isDisabled"
                            v-model="formLabelAlign.userName"
                            style="width: 300px"
                            placeholder="请输入买家名称"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="elFormBox">
                    <el-form-item :label="formLabelAlign.type==0?'社会信用代码：':'身份证号码：'" prop="idCard">
                    <el-input
                        :disabled="isDisabled"
                        v-model="formLabelAlign.idCard"
                        style="width: 300px"
                        placeholder="请输入"
                    ></el-input>
                    </el-form-item>
                    <el-form-item label="联系人：" prop="linkUserName">
                    <el-input
                        :disabled="isDisabled"
                        v-model="formLabelAlign.linkUserName"
                        style="width: 300px"
                        placeholder="请输入联系人"
                    ></el-input>
                    </el-form-item>
                </div>
                <div class="elFormBox">
                    <el-form-item label="联系电话：" prop="linkUserPhone">
                    <el-input
                        :disabled="isDisabled"
                        v-model="formLabelAlign.linkUserPhone"
                        style="width: 300px"
                        placeholder="请输入联系电话"
                    ></el-input>
                    </el-form-item>
                    <div class="idCars">
                    <div style="display: flex; margin-left: 40px">
                        <div class="idCarsIcon">*</div>
                        <el-form-item
                        :label="formLabelAlign.type==1?'身份证正反面：':'营业执照：'"
                        label-width="90px"
                        ></el-form-item>
                    </div>

                    <div style="position: relative" class="upload">
                        <el-upload
                        v-if="!carImg"
                        class="upload-demo"
                        action="/hxkj_management_server_api/com/file/fileUpload"
                        :on-change="handleChange"
                        :file-list="fileList"
                        :on-success="successImg"
                        :show-file-list="false"
                        >
                        <div class="uploadCar">
                            <div><i class="el-icon-plus"></i></div>
                            <div class="ftcB4 fs14" style="padding: 4px 0" v-if="formLabelAlign.type==1">
                            请上传身份证人像面照片
                            </div>
                        </div>
                        </el-upload>
                        <div class="avatar-box" v-if="showcarImg">
                            <img :src="showcarImg" alt="" />
                            <i class="el-icon-close clearVideo" @click="clearVideo" v-if="!carImg"></i>
                        </div>
                        <el-upload
                        v-if="!carImg1 && formLabelAlign.type==1"
                        class="upload-demo"
                        action="/hxkj_management_server_api/com/file/fileUpload"
                        :on-change="handleChange"
                        :file-list="fileList1"
                        :on-success="successImg1"
                        :show-file-list="false"
                        >
                        <div class="uploadCar">
                            <div><i class="el-icon-plus"></i></div>
                            <div class="ftcB4 fs14" style="padding: 4px 0">
                            请上传身份证国徽面照片
                            </div>
                        </div>
                        </el-upload>
                        <div class="avatar-box" v-if="showcarImg1">
                        <img :src="showcarImg1" alt="" />
                        <i class="el-icon-close clearVideo" @click="clearVideo1" v-if="!carImg"></i>
                        </div>
                    </div>
                    </div>
                </div>
                <!-- <div class="codeIcon mb10 ml20r">资质信息：</div> -->
                <titleBar title="资质信息"></titleBar>
                <div class="elFormBox pl30 ml20r mb20">
                    <el-upload
                    :disabled="isDisabled"
                    class="upload-demo"
                    drag
                    action="/hxkj_management_server_api/com/file/fileUpload"
                    :on-success="successaptitudeUrl"
                    :on-remove="clearaptitudeUrl"
                    :file-list="fileList2"
                    multiple
                    >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <!-- <div class="el-upload__tip" slot="tip">
                        只能上传jpg/png文件，且不超过500kb
                    </div> -->
                    </el-upload>
                </div>
                </el-form>
            </div>
        </div>
        
        <!-- 项目即将开始及以后展示  && form.auditStatus==2-->
        <div style="margin-bottom:30px" v-if="detailsForm.progressStatus >3">
            <titleBar title="项目进展情况"></titleBar>
            <div class="flexDiv">
                <!-- <div class="flexDiv_right">
                    <span>报名人数：</span>
                    <span>{{ detailsForm.signQuantity || '0'}}人</span>
                </div> -->
                <div class="flexDiv_right">
                    <span>报价人数：</span>
                    <span class="boldText">{{ detailsForm.offerQuantity || '0' }}人</span>
                </div>
                <div class="flexDiv_right">
                    <span>延时次数：</span>
                    <span class="boldText">{{detailsForm.delayQuantity || '0'}}次</span>
                </div>
                <div class="flexDiv_right">
                    <span>竞买结束时间：</span>
                    <span class="boldText">{{detailsForm.finallyAuctionEndTime || '--'}}</span>
                </div>
            </div>
            <div class="project-box">项目进行明细</div>
            <el-table 
                empty-text="暂无数据"
                max-height="430px"
                :data="tableData" style="width: 100%" stripe>
                <el-table-column label="序号" prop="" type="index" width="70px"></el-table-column>
                <el-table-column label="状态" prop="bidStatus" width="">
                    <template v-slot="scope">
                        <span v-if="scope.row.bidStatus==0">出局</span>
                        <span v-else-if="scope.row.bidStatus==1" class="redColor">领先</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="竞买号" prop="auctionAccount" width=""></el-table-column>
                <el-table-column label="出价金额(元)" prop="bidMoney" width="">
                    <template v-slot="scope">
                        <span>{{scope.row.bidMoney?(scope.row.bidMoney/100).toFixed(2):'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="出价时间" prop="createTime" width="">
                    <template v-slot="scope">
                        <span>{{scope.row.createTime?scope.row.createTime:'--'}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 项目结束 -->
        <div v-if="detailsForm.progressStatus==5 && form.isWinningBuyer==1">
            <titleBar title="项目结算"></titleBar>
            <div class="flexDiv">
                <div class="flexDiv_left">
                    <span>胜出价格：</span>
                    <span>￥{{ settlementForm.winOutMoney || '--'}}</span>
                </div>
                <div class="flexDiv_right">
                    <span>结算数量：</span>
                    <span class="boldText">{{ settlementForm.settlementNum || '--' }}{{settlementForm.companyName}}</span>
                </div>
                <div class="flexDiv_right">
                    <span>结算总价：</span>
                    <span class="boldText">￥{{settlementForm.settleStatus==0?'--':settlementForm.settleMoney}}</span>
                </div>
                <div class="flexDiv_right">
                    <span>结算时间：</span>
                    <span class="boldText">{{settlementForm.accountingTime || '--'}}</span>
                </div>
            </div>
            <div style="display: flex;">
                <span style="font-size: 14px;color: #3d3d3d">标的物明细：</span>
                <el-table 
                    empty-text="暂无数据"
                    :data="tableData2" style="width: 60%;margin-bottom:30px" stripe>
                    <el-table-column label="序号" prop="" type="index" width="100px"></el-table-column>
                    <el-table-column label="标的物名称" prop="auctionMarkName" width=""></el-table-column>
                    <el-table-column label="数量" prop="createTime" width="">
                        <template v-slot="scope">
                            <span>{{scope.row.auctionMarkNum}}{{scope.row.companyName}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            

            <div v-if="settlementForm.settleStatus!=2 && settleProofUrl.length>0" class="mb20">
                <p style="font-size:14px;color: #3d3d3d">结算凭证：</p>
                <div v-for="(item,index) in settleProofUrl" :key="index" class="ml60r">
                    <div class="flex-form" @click="uploadClick(item)">
                        <div class="mb10 names"><i class="el-icon-document mr10"></i>{{item.name}}</div>
                        <div class="mb10 ml10r pointer"><i class="el-icon-download blueColor2"></i></div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import titleBar from "@/components/titleBar";
import regular from "@/util/regular";
import {employAuctionUserDtails,
auctionProjectDetailsById,
updateAuctionUser,
projectProgressDetail,
auctionSettleDetailsById,
getProgressStatusEndTime,
loginOut,
} from "@/api/auction/index.js";
import { fileDownLoad } from "@/api/index.js";
import { imageEcho } from "@/api/index";
import {ride,except} from "@/util/accuracy"
export default {
    components: {
        titleBar
    },
    data() {
    var validateMaterialConsigneePhone = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.testPhone(value),
        "请输入正确的手机号"
    );
      return{
        except,
        auctionAccount: sessionStorage.getItem("auctionAccount"),
        form:{},
        detailsForm:{},
        formLabelAlign: {
            auctionProjectId: "",
            userName: "",
            idCard: "",
            linkUserName: "",
            linkUserPhone: "",
            type: null,
            imageUrl: "",
            aptitudeUrl: "",
            code: "",
            uuid: "",
        },
        fileList: [],
        fileList1: [],
        fileList2: [],
        carImg: "",
        showcarImg: "",
        carImg1: "",
        showcarImg1: "",
        settlementForm: {},//项目结算明细
        aptitudeUrlList: [],
        tableData: [],//项目进行明细列表
        tableData2: [],//标的物明细列表
        settleProofUrl: [],//结算凭证
        rules: {
            type: [{required: true, message: "请选择买家性质", trigger: "blur,change"}],
            code: [{required: true,message: "请输入短信验证码",trigger: "blur,change"}],
            userName: [{required: true,message: "请输入买家名称",trigger: "blur"}],
            idCard: [{required: true,message: "请输入",trigger: "blur"}],
            linkUserName: [{required: true,message: "请输入linkUserName",trigger: "blur"}],
            linkUserPhone: [
                { required: true, message: "请输入联系电话", trigger: "blur"},
                { required: true, validator: validateMaterialConsigneePhone, trigger: "blur",},
            ],
        },
        auctionProjectId: "",
        timer1: null,
        daysTime: null,
        hoursTime: null,
        minutesTime: null,
        secondsTime: null,
        isDisabled: true,
      }  
    },
    beforeDestroy() {
        this.clearIntervalData()
    },
    mounted(){
        this.auctionProjectId = this.$route.query.auctionProjectId || ""
        if(this.auctionProjectId) {
            this.getProgressStatusEndTime(this.auctionProjectId)
        }
        this.employAuctionUserDtails()
    },
    methods:{
        clearIntervalData() {
            window.clearInterval(this.timer1);
        },
        // 新接口拿取当前时间
        getProgressStatusEndTime(id) {
            getProgressStatusEndTime({auctionProjectId:id}).then(res=>{
                if (res.data.code == 1) {
                    let data = res.data.data || {}
                    let time = data.progressStatus == 3 ? data.auctionStartTime : data.finallyAuctionEndTime;
                    if(data.progressStatus<5) {
                        this.timer1 = setInterval(()=>{this.getCurrentTime(time,data.systemTime)}, 1000);
                    }
                }
            })
        },
        // 设计倒计时
        getCurrentTime(time,systemTime) {
            // 将日期时间字符串转换为Date对象
            let date1 = new Date(time);
            let date2 = new Date();//系统时间
            let diff = 0;
            diff = date1.getTime() - date2.getTime();
            if(diff<0) {
                this.clearIntervalData()
                this.getAllProject(this.auctionProjectId)
                this.employAuctionUserDtails()
            }
            // console.log(diff,"000----111")
            // 使用毫秒数计算相差的天、小时、分钟、秒
            let days = Math.floor(diff / (1000 * 60 * 60 * 24));
            diff -= days * 1000 * 60 * 60 * 24;
            let hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            let minutes = Math.floor(diff / 1000 / 60);
            diff -= minutes * 1000 * 60;
            let seconds = Math.floor(diff / 1000);
            let timeText = days+'天'+ hours + "时" + minutes + "分" + seconds + '秒';
            this.daysTime = days>=10?days: '0'+ days
            this.hoursTime = hours>=10?hours: '0'+hours
            this.minutesTime = minutes>=10?minutes: '0'+minutes
            this.secondsTime = seconds>=10?seconds: '0'+seconds
            this.currentTime =  timeText>=10?timeText: '0'+timeText
            // if(this.currentTime=='00天00时00分00秒') {
            //     clearInterval(this.time1)
            //     this.getAllProject(this.auctionProjectId)
            //     this.employAuctionUserDtails()
            // }
        },
        // 资质详情
        employAuctionUserDtails(){
            employAuctionUserDtails({}).then(res=>{
                if(res.data.code == 1){
                    this.form = res.data.data || {};
                    this.formLabelAlign = res.data.data || {};
                    if(this.formLabelAlign.imageUrl) {
                        let imageUrlList = this.formLabelAlign.imageUrl.split(",")
                        imageEcho({imgPath:imageUrlList[0]}).then((res) => {
                            this.showcarImg = res.data.data.imageCode;
                            this.carImg = imageUrlList[0]
                        });
                        if(imageUrlList[1]) {
                            imageEcho({imgPath:imageUrlList[1]}).then((res) => {
                                this.showcarImg1 = res.data.data.imageCode;
                                this.carImg1 = imageUrlList[1]
                            });
                        }
                        
                        this.fileList2 = JSON.parse(this.formLabelAlign.aptitudeUrl)
                    }
                    this.getAllProject(this.form.auctionProjectId)
                    this.getAllProjectMessageDetails(this.form.auctionProjectId)
                    this.getAllProjectSettlement(this.form.auctionProjectId)
                }
            })
        },
        // 整条项目的详情
        getAllProject(auctionProjectId) {
            auctionProjectDetailsById({auctionProjectId:auctionProjectId}).then(res=>{
                if(res.data.code==1) {
                    this.detailsForm = res.data.data || {};
                    if(this.detailsForm.bondIs ==1) {
                        this.detailsForm.bond = except(this.detailsForm.bond,100).toFixed(2)
                    }
                    this.detailsForm.startingPrice = except(this.detailsForm.startingPrice,100).toFixed(2)
                    this.detailsForm.priceIncrease = except(this.detailsForm.priceIncrease,100).toFixed(2)
                }
            })
        },
        // 获取项目进展明细（列表数据）
        getAllProjectMessageDetails(auctionProjectId) {
            projectProgressDetail({auctionProjectId:auctionProjectId}).then(res=>{
                if(res.data.code==1) {
                    this.tableData = res.data.data || []
                }
            })
        },

        // 获取项目结算明细
        getAllProjectSettlement(auctionProjectId) {
            auctionSettleDetailsById({auctionProjectId:auctionProjectId}).then(res=>{
                if(res.data.code==1) {
                    let data = res.data.data || {};
                    this.settlementForm = data || {};
                    this.settlementForm.winOutMoney = except(this.settlementForm.winOutMoney,100).toFixed(2)
                    this.settlementForm.settleMoney = except(this.settlementForm.settleMoney,100).toFixed(2)
                    this.tableData2 = data.auctionSettleDetailsList || []
                    if(data.settleProofUrl) {
                        this.settleProofUrl = JSON.parse(data.settleProofUrl)
                    }
                }
            })
        },
        // 资质信息下载
        uploadClick(item) {
            let fileName = item.name;
            fileDownLoad({ filePath: item.url }).then((res) => {
                if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(res, fileName);
                } else {
                let aTag = document.createElement("a");
                aTag.download = fileName;
                aTag.href = URL.createObjectURL(res);
                aTag.click();
                URL.revokeObjectURL(aTag.href);
                }
            });
        },
        handleChange() {},
         /* 图片上传成功 */
        successImg(res, file) {
            if (res.code == 1) {
                this.showcarImg = this.fileUploadapi(res.data[0].filePath);
                this.carImg = res.data[0].filePath;
            } else {
                this.$message.error(res.msg);
            }
        },
        successImg1(res, file) {
            if (res.code == 1) {
                this.showcarImg1 = this.fileUploadapi1(res.data[0].filePath);
                this.carImg1 = res.data[0].filePath;
            } else {
                this.$message.error(res.msg);
            }
        },
            clearVideo() {
                this.carImg = "";
                this.showcarImg = "";
            },
            clearVideo1() {
                this.carImg1 = "";
                this.showcarImg1 = "";
            },
        /* 回填图片回显 */
        fileUploadapi(imgPath) {
            imageEcho({ imgPath}).then((res) => {
                this.showcarImg = res.data.data.imageCode;
            });
        },
        fileUploadapi1(imgPath) {
            imageEcho({imgPath}).then((res) => {
                this.showcarImg1 = res.data.data.imageCode;
            });
        },
        /* 图片上传成功 */
        successaptitudeUrl(res, file) {
            if (res.code == 1) {
                this.fileList2.push({
                name: res.data[0].fileName,
                url: res.data[0].filePath,
                });
            } else {
                this.$message.error(res.msg);
            }
        },
        /* 删除图片 */
        clearaptitudeUrl(file, fileList) {
            this.fileList2 = fileList.map((item) => {
                return { name: item.name, url: item.response.data[0].filePath };
            });
        },
        editClick() {
            this.isDisabled = false
        },
        editForm() {
            let data = { ...this.formLabelAlign };
            if(this.carImg && this.carImg1=="") {
                data.imageUrl = this.carImg
            } 
            if(this.carImg && this.carImg1) {
                data.imageUrl = this.carImg+ "," + this.carImg1
            }
            // data.imageUrl = this.carImg + "," + this.carImg1;
            data.aptitudeUrl = JSON.stringify(this.fileList2);
            data.lastLogin = this.formLabelAlign.lastLogin
            // auditStatus 传0 资质被驳回后 重新编辑数据审核
            if(this.form.auditStatus == 2) {
                data.auditStatus = 0
            } else {
                data.auditStatus = null
            }
            this.$refs.formLabelAlign.validate((valid) => {
                if(valid) {
                    updateAuctionUser(data).then((res) => {
                        if (res.data.code == 1) {
                            this.carImg = ""
                            this.carImg1 = ""
                            this.isDisabled = true
                            this.$refs.formLabelAlign.resetFields();
                            this.$message.success("编辑成功！")
                            this.employAuctionUserDtails()
                        }
                    });
                }
            })
        },
        goBack() {
            this.$router.go(-1)
        },
        projectClick() {
            this.$router.push({
                name:'projectDetailsJm',
                query:{
                    auctionProjectId:this.form.auctionProjectId
                }
            })
        },
        resetLogin() {
            loginOut().then(res=>{
                if(res.data.code==1) {
                    sessionStorage.clear()
                    this.$router.push({ name: "competitionBuy" });
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.bigBox{
    flex: 1;
    width: 1200px;
    margin: 0 auto;
    .header{
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .user {
        margin-right: 15px;
        color: #a8abb2;
        font-size: 16px;
        font-weight: bold;
    }
    .top-tip-box {
        height: 240px;
        background: #F0F1F1;
        margin-top: 20px;
        position: relative;
    }
    .tips {
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        line-height: 24px;
    }
    .tips-one {
        text-align: center;
        font-size: 16px;
        font-weight: normal;
        line-height: 22px;
    }
    .mt120 {
        margin-top: 120px;
    }
}
.flexDiv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #3d3d3d;
    .w240 {
        width: 250px;
    }
    .flex1 {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .checkPay {
        color: #409eff;
        font-size: 12px;
        cursor: pointer;
    }
    .flexDiv_left {
        width: 388px;
        color: #3d3d3d;
        // background: red;
        // font-size: 16px;
    }
    .flexDiv_right {
        // flex: 1;
        color: #3d3d3d;
        // font-size: 16px;
    }
}

.dividing-line {
    width: 100%;
    border-bottom: 1px dashed #B2B6B6;
    margin:50px 0;
}
.elFormBox {
    display: flex;
    justify-content: space-between;
    /deep/.el-form-item {
      flex: 1;
    }
    .idCars {
      flex: 1;
    }
}
.idCars {
    display: flex;
    padding-bottom: 40px;
    width: 430px !important;
}
.idCarsIcon {
    color: #f56c6c;
    padding-top: 7px;
}
.upload {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.uploadCar {
    border-radius: 5px;
    border: 1px dashed #e5e5e5;
    width: 200px;
    height: 120px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-right: 10px;
}
.sureBtn {
    width: 90px;
    height: 32px;
    background: #15d393;
    border: none;
    color: #fff;
    font-size: 12px;
    
}
.footer {
    text-align: center;
    margin:20px
}
.avatar-box {
    position: absolute;
    top: 0;
    position: relative;
    margin-right: 10px;
    img {
        width: 200px;
        height: 120px;
        display: block;
    }
}
  .clearVideo {
    position: absolute;
    color: red;
    top: 3px;
    right: 2px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
  }
.mess-btn {
    display: flex;
    justify-content: space-between;
}
.project-box {
    text-align: center;
    margin: 20px 0;
    font-weight: 600;
}
.flex-form {
    display: flex;
    align-items: center;
    cursor: pointer;
}
.names {
    width:350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.times-box {
    padding-top:5px;
    margin-left: 20px;
}
.codes {
    color: #409eff;
    text-decoration: underline;
    cursor: pointer; 
}
.time-details {
    display: flex;
    position: absolute;
    .time-case {
        padding: 10px;
        border-radius: 5px;
        // margin-right: 10px;
        color: #fff;
        font-weight: 600;
    }
    .time-kuang {
        text-align: center;
        margin-top: -10px;
    }
    .time-symbol {
        font-size: 25px;
        color: #606266;
        // margin-left: 5px;
        // margin-right: 5px;
        // margin-top: 18px;
        margin: 9px 5px 0 5px;
    }
    .zhongwen {
        font-size: 14px;
        color: #3D3D3D;
        margin-top: -15px;
    }
}
.hongColor {
    background: #EE8A8A;
}
.lvColor {
    background: #4EDEAE;
}
.lanColor {
    background: #3398DA;
}
.huangColor {
    background: #F39C11;
}
.redColor {
    color: #E53E3E;
}
</style>


// WEBPACK FOOTER //
// src/views/competitionBuy/my.vue